import AudioDataMgr from './AudioDataMgr';
export default class AudioPeaks extends PIXI.utils.EventEmitter{
    constructor(id){
        super();
        this.buffer = null;

        this.max = 0;
        this.sampleRate = 36;
        this.peaks = null;

        this.id = id;
        AudioDataMgr.instance.getData(id, this._onBufferLoaded, this);
    }

    _onBufferLoaded(buffer){
        const howl = new Howl({src: buffer});
        howl.on("load", ()=>{
            this.buffer = howl.getBuffer();
            if(this.buffer){
                this.emit('load');
            }
        });
        //howler全局缓存命中同src时'load'可能在on注册前已发完，直接补读
        if(!this.buffer && howl.state && howl.state() === "loaded"){
            this.buffer = howl.getBuffer();
            if(this.buffer){
                this.emit('load');
            }
        }
    }

    _getPeaks(){
        if(this.peaks){
            return this.peaks;
        }
        const buffer = this.buffer;
        const len = buffer.length;
        const sampleSize = buffer.sampleRate / this.sampleRate;
        const sampleStep = ~~(sampleSize / 10) || 1;
        const channels = this.buffer.numberOfChannels;

        const frameCnt = Math.ceil(buffer.duration * this.sampleRate);

        const peaks = this.peaks = [];
        peaks[frameCnt - 1] = 0;

        let totalMax = 0;
        for (let c = 0; c < channels; c++) {
            const chan = this.buffer.getChannelData(c);
            const chanLen = chan.length;
 
            for (let i = 0; i < frameCnt; i++) {
                const start = ~~(i * sampleSize);
                const end = Math.min(~~(start + sampleSize), chanLen);
                let max = 0;
                let j;

                for (j = start; j < end; j += sampleStep) {
                    const value = chan[j];
                    if (value > max) {
                        max = value;
                        totalMax = Math.max(totalMax, max);
                    }
                }
                peaks[i] = max;
            }
        }

        this.max = totalMax;

        return this.peaks;
    }

    get loaded(){
        return this.buffer !== null;
    }

    getRangePeaks(start, end){
        const peaks = this._getPeaks();
        if(this.max === 0){
            return [];
        }

        start = Math.max(Math.ceil(start * this.sampleRate), 0);
        end = Math.min(Math.ceil(end * this.sampleRate), peaks.length);

        const results = [];
        const oneOverMax = 1/ this.max;
        for(let i = start; i < end; i++){
            results.push(peaks[i] * oneOverMax);
        }
        return results;
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/component/AudioPeaks.js